import { rest } from 'msw';
import highlightsValid from '../fixtures/highlights-valid.json';
import { generateGrowthNorms, generatePerformanceNorms } from './utils';
import SchoolDistrictData from '../fixtures/input.json';
const { combined } = SchoolDistrictData;

const growthPercentilesResolver = async (req, res, ctx) => {
    console.log('------- GROWTH PERCENTILES MSW INTERCEPT ------- ', req.params);
    const body = await req.json();

    let result = [];
    if (Array.isArray(body)) {
        result = body.map((input) => {
            const percentile = parseInt(input.grade) * 7;
            return {
                studentGrowthPercentile: percentile,
                studentConditionalGain: 3.98370781115515,
                studentConditionalGrowthIndex: 0.313602875910184,
                endingRit: input.endingRit,
                endingSeason: input.endingSeason,
                endingSem: input.endingSem,
                endingWeek: input.endingWeek,
                grade: input.grade,
                startingRit: input.startingRit,
                startingSeason: input.startingSeason,
                startingSem: input.startingSem,
                startingWeek: input.startingWeek,
                subject: input.subject,
            };
        });
    }
    return res(ctx.status(200), ctx.json(result));
};

const growthProjectionsResolver = async (req, res, ctx) => {
    console.log('------- GROWTH PROJECTIONS MSW INTERCEPT ------- ', req.params);
    const body = await req.json();
    let result = [];
    if (Array.isArray(body)) {
        result = body.map((input) => {
            const growth = parseInt(input.grade % 13) + 1;
            const percentile = parseInt(input.grade) * 7;
            return {
                endingTerm: input.endingTerm,
                endingWeek: input.endingWeek,
                grade: input.grade,
                startingRit: input.startingRit,
                startingSem: input.startingSem,
                startingWeek: input.startingWeek,
                subject: input.subject,
                predictedGrowth: growth,
                predictedScore: input.startingRit + growth,
                predictedScorePercentile: percentile,
            };
        });
    }
    return res(ctx.status(200), ctx.json(result));
};

const normRitBatchResolver = async (req, res, ctx) => {
    console.log('------- NORM RIT BATCH MSW INTERCEPT ------- ', req.params);

    let result = [];
    const body = await req.json();
    if (Array.isArray(body)) {
        result = body.map((input) => {
            const grade = input.grade % 13; // handle kindergarten
            const mockStudentRit = (grade * parseInt(input.percentile)) / 4.7 + 100; //value between 100 and 305 or so
            return {
                grade: input.grade,
                percentile: input.percentile,
                subject: input.subject,
                termNumber: input.termNumber,
                weeks: input.weeks,
                studentRit: mockStudentRit,
                schoolRit: mockStudentRit * 0.8,
            };
        });
    }

    return res(ctx.status(200), ctx.json(result));
};

export default [
    rest.put('/gateway/api/goals/:growthGoalBid', async (req, res, ctx) => {
        // this implementation takes advantage of the fact that the growthGoalBid contains the studentBid
        const { growthGoalBid } = req.params;
        const allStudentBids = Object.keys(combined);
        const matchingStudentBids = allStudentBids.filter((bid) => growthGoalBid.includes(bid));
        if (matchingStudentBids.length !== 1) {
            throw new Error(`could not find studentBid to match ${growthGoalBid}}`);
        }

        const studentBid = matchingStudentBids[0];
        const matchingGrowthGoal = combined[studentBid].growthGoals.find(
            (goal) => goal.growthGoalBid === growthGoalBid
        );
        if (matchingGrowthGoal === undefined) {
            throw new Error(`could not find growthGoalBid to match ${growthGoalBid}}`);
        }

        const requestPayload = await req.json();
        const updatedGoal = {
            ...matchingGrowthGoal,
            ...requestPayload,
            dateEdited: Date.now(),
        };
        const remainingGrowthGoals = combined[studentBid].growthGoals.filter(
            (goal) => goal.growthGoalBid !== growthGoalBid
        );
        combined[studentBid].growthGoals = [...remainingGrowthGoals, updatedGoal];

        return res(ctx.status(200), ctx.json(updatedGoal));
    }),

    rest.post('/gateway/api/partners/hometown-school-district/students/:studentBid/goals', async (req, res, ctx) => {
        // adds a new goal
        const studentBid = req.params.studentBid;
        const {
            actionPlan,
            targetScore,
            startTermScore,
            startTermNumber,
            startTermWeeksOfInstruction,
            endTermScore,
            endTermNumber,
            endTermWeeksOfInstruction,
            predictedGrowth,
            typicalScore,
            subject,
            educatorBid,
        } = await req.json();
        const newGoal = {
            growthGoalBid: `${studentBid}-${Date.now()}`,
            actionPlan,
            targetScore: targetScore || null,
            startTermScore: startTermScore || null,
            startTermNumber: startTermNumber || null,
            startTermWeeksOfInstruction: startTermWeeksOfInstruction || null,
            endTermScore: endTermScore || null,
            endTermNumber: endTermNumber || null,
            endTermWeeksOfInstruction: endTermWeeksOfInstruction || null,
            predictedGrowth: predictedGrowth || null,
            typicalScore: typicalScore || null,
            subject,
            dateEdited: Date.now(),
            educatorBid,
            educatorName: 'Mock Educator', // this is a hack, but it shouldn't matter
        };
        combined[studentBid].growthGoals.push(newGoal);

        return res(ctx.status(200), ctx.json(newGoal));
    }),
    rest.get('/gateway/api/partners/:partnerBid/students/:studentBid/combined', (req, res, ctx) => {
        console.log('------- COMBINED MSW INTERCEPT ------- ', req.params);
        const studentBid = req.params.studentBid;
        const combinedData = combined[studentBid] || {};

        return res(ctx.status(200), ctx.json(combinedData));
    }),
    rest.get('/gateway/api/partners/:partnerBid/students/:studentBid/highlights', (req, res, ctx) => {
        console.log('------- HIGHLIGHTS MSW INTERCEPT ------- ', req.params);

        return res(ctx.status(200), ctx.json(highlightsValid));
    }),
    rest.post('/gateway/api/norms/rit/batch', normRitBatchResolver),
    rest.post('/gateway/api/norms/growth-projections', growthProjectionsResolver),
    rest.post('/gateway/api/norms/growth-percentiles', growthPercentilesResolver),
    // let webpack-dev-server handle static assets
    rest.get(/.+\.(png|svg|woff2)$/, (req) => req.passthrough()),
    rest.get('/gateway/api/norms/status/preview', (req, res, ctx) => {
        const statusNorms = generatePerformanceNorms(req);
        return res(ctx.status(200), ctx.json(statusNorms));
    }),
    rest.get('/gateway/api/norms/growth/preview', (req, res, ctx) => {
        return res(ctx.status(200), ctx.json(generateGrowthNorms(req)));
    }),
    rest.get('/', (req) => req.passthrough()),
];
